import { useEffect, useRef } from 'react';

//custom hook not to run on initial render
const useRefreshEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
}

export default useRefreshEffect;